import { Component, DoCheck, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { KngButtonState } from 'kinetic-angular';
import { Role, Permission, RolePermissionLabel, PermissionData } from '..';
import { RoutePermissions } from '../../../guards/permission/definitions';
import { RolesPermissionsService } from '../roles-permissions.service';
@Component({
	selector: 'tmhna-portal-roles-permissions-details',
	templateUrl: './roles-permissions-details.component.html',
	styleUrls: ['./roles-permissions-details.component.scss']
})
export class RolesPermissionsDetailsComponent implements DoCheck, OnInit
{

	@Output() isDirty = new EventEmitter<boolean>();
	@Input() editPermissions!: RoutePermissions | undefined;
	descriptionArray: string[] = [];

	constructor(
		public rolesService: RolesPermissionsService,
		public element: ElementRef
	) { }
	get selectedRole(): Role
	{
		return this.rolesService.rolesList[this.rolesService.selectedRoleIndex];
	}

	get permissionsList(): Permission[]
	{
		return this.rolesService.labels.permissionLabels;
	}

	get roleNames(): string[]
	{
		return this.rolesService.roleNameList;
	}

	get labels(): RolePermissionLabel
	{
		return this.rolesService.labels;
	}

	get saveButtonState(): KngButtonState
	{
		return this.rolesService.saveButtonState;
	}

	ngDoCheck(): void
	{
		if (this.selectedRole)
			this.rolesService.saveButtonState.disabled = this.disableSave();
	}

	ngOnInit(): void
	{
		this.rolesService.contentUpdatedObservable$.subscribe((updated)=>
		{
			if(updated)
			{
				setTimeout(() => 
				{
					this.textAreaAutoSize();
				}, 100);
				this.rolesService.updatedContent = false;
			}
		});
		this.rolesService.isSaveSucess$.subscribe((res: boolean) =>
		{
			this.isDirty.emit(res);
		});
	}

	setPermissonStatus(id: string)
	{
		return this.selectedRole.permissions.includes(id);
	}

	updatePermissonStatus(event: Event, id: string)
	{
		this.isDirty.emit(true);
		const index = this.selectedRole.permissions.findIndex((el) => el === id);
		if ((event.target as HTMLInputElement).checked)
		{
			if (index === -1)
			{
				this.selectedRole.permissions.push(id);
			}
		}
		else
		{
			this.selectedRole.permissions.splice(index, 1);
		}
	}

	unSelectAll(section: Permission)
	{
		this.isDirty.emit(true);
		section.permissionArr.forEach((permission: PermissionData) =>
		{
			const indexOfEl = this.selectedRole.permissions.findIndex(
				(el) => el === permission.permissionId
			);
			if (indexOfEl !== -1)
			{
				this.selectedRole.permissions.splice(indexOfEl, 1);
			}
		});
	}

	onChangingDescription()
	{
		this.isDirty.emit(true);
	}
	isAllPermissionFalse(section: Permission)
	{
		let permissionArrLength = 0;
		section.permissionArr.forEach((permission: PermissionData) =>
		{
			const indexOfEl = this.selectedRole?.permissions.findIndex(
				(el) => el === permission.permissionId
			);
			if (indexOfEl === -1)
			{
				permissionArrLength++;
			}
		});

		return permissionArrLength === section.permissionArr.length;
	}

	roleNameValidation(textData: string | null)
	{
		this.isDirty.emit(true);
		this.selectedRole.isInvalidText = false;
		if (textData)
		{
			const regex = /^[a-zA-Z0-9 ]*$/;
			if (!regex.test(textData))
			{
				this.selectedRole.isInvalidText = true;
			}
			else
			{
				this.selectedRole.isInvalidText = false;
			}
		}
		else
		{
			this.selectedRole.isInvalidText = false;
		}
	}

	isDuplicateName(): boolean
	{
		const indexOfMatch = this.roleNames.findIndex(
			(el) =>
				el.toLowerCase().trim() === this.selectedRole.name.toLowerCase().trim()
		);
		if (
			indexOfMatch !== -1 &&
			indexOfMatch !== this.rolesService.selectedRoleIndex
		)
			return false;
		return true;
	}

	isPermissionConfigured(): boolean
	{
		return this.selectedRole.permissions.length > 0;
	}

	disableSave()
	{
		const regex = /^[a-zA-Z0-9 ]*$/;
		return (
			this.checkSelectedRole() ||
			!this.isDuplicateName() ||
			!this.isPermissionConfigured() ||
			!regex.test(this.selectedRole.name)
		);
	}

	checkSelectedRole(): boolean
	{
		return (
			(this.selectedRole.locked ?? false) ||
			this.selectedRole.name?.trim() === '' ||
			!this.selectedRole.description
		);
	}

	saveRole()
	{
		if (!this.selectedRole.id)
		{
			this.rolesService.saveCustomRole(this.selectedRole);
		}
		else
		{
			this.rolesService.updateCustomRole(this.selectedRole);
		}
		this.rolesService.trackSaveRoleAnalyticsEvent();
	}


	@ViewChild('textDescription') textArea!: ElementRef;
	textAreaAutoSize()
	{		
		if(this.textArea)
		{
			this.textArea.nativeElement.style.height = 0 + 'px';
			this.textArea.nativeElement.style.height = (this.textArea.nativeElement.scrollHeight + 4) + 'px';
		}
	}
}
